export default "__VITE_ASSET__B4ykZA8T__"